import { render, staticRenderFns } from "./shipments-grid.vue?vue&type=template&id=709a891a&scoped=true&"
import script from "./shipments-grid.ts?vue&type=script&lang=ts&"
export * from "./shipments-grid.ts?vue&type=script&lang=ts&"
import style0 from "./shipments-grid.scss?vue&type=style&index=0&id=709a891a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709a891a",
  null
  
)

export default component.exports